import React, { useEffect, useState } from 'react';

import OrderTemplatesEdit from '@components/shared/order_templates/OrderTemplatesEdit';
import { useAdminOrderTemplateService } from '@hooks/admin/useAdminOrderTemplateService';

interface SalesChannelOption {
  label: string;
  value: string;
  [key: string]: unknown;
}

const AdminOrderTemplateEdit: React.FC = () => {
  const service = useAdminOrderTemplateService();
  // Admin 端沒有 merchant-scoped context；自行 fetch 一次 sales channels 後注入 shared，
  // 與 operator wrapper 行為對齊（shared 不再自行 self-fetch）。
  const [salesChannels, setSalesChannels] = useState<SalesChannelOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    service.getSalesChannels().then((data: SalesChannelOption[]) => {
      if (cancelled) return;
      setSalesChannels(data || []);
    }).catch((error: unknown) => {
      if (cancelled) return;
      console.error('Failed to fetch admin sales channels', error);
      setSalesChannels([]);
    });
    return () => {
      cancelled = true;
    };
  }, [service]);

  return (
    <OrderTemplatesEdit role="admin" service={service} salesChannels={salesChannels} />
  );
};

export default AdminOrderTemplateEdit;
